import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { LoaderService } from "../../customer-area/tool-bar/shared/loader/loader.service";

@Injectable({
  providedIn: "root"
})
export class LoaderInterceptor implements HttpInterceptor {
  public constructor(private loaderService: LoaderService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.loaderService.addHttpCall();
      return next.handle(request).pipe(
        finalize(() => {
          this.loaderService.removeHttpCall();
        } )
      )
  }
}
